import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  Output,
  EventEmitter,
  HostListener,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[cropOverlay]'
})
export class CropOverlayDirective implements OnDestroy {

  @Output() cropClick = new EventEmitter<void>();

  private wrapper?: HTMLElement;
  private overlay?: HTMLElement;



  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2
  ) { }

  @HostListener('load')
  onImageLoad() {
    this.destroyOverlay(); // prevent duplicates
    this.initOverlay();
  }
  private initOverlay() {
    const img = this.el.nativeElement;

    if (!img || !img.src || img.src == '') return;

    this.createWrapper();
    this.createOverlay();
    this.attachHoverEvents();
  }
  private createWrapper() {
    const img = this.el.nativeElement;
    this.renderer.setStyle(img, 'display', 'block');
    this.renderer.setStyle(img, 'width', '100%');
    this.renderer.setStyle(img, 'height', '100%');

    this.wrapper = this.renderer.createElement('div');
    this.renderer.setStyle(this.wrapper, 'position', 'relative');
    this.renderer.setStyle(this.wrapper, 'display', 'inline-block');
    this.renderer.setStyle(this.wrapper, 'height', '100%');

    const parent = img.parentNode!;
    if (parent) {
      this.renderer.insertBefore(parent, this.wrapper, img);
      this.renderer.appendChild(this.wrapper, img);
    }

  }

  private createOverlay() {
    this.overlay = this.renderer.createElement('div');

    Object.entries({
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.5)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      opacity: '0',
      transition: 'opacity 0.2s',
      zIndex: '10'
    }).forEach(([key, value]) =>
      this.renderer.setStyle(this.overlay, key, value)
    );

    const text = this.renderer.createText('Crop Image');
    this.renderer.appendChild(this.overlay, text);

    this.renderer.listen(this.overlay, 'click', () => {
      this.cropClick.emit();
    });

    this.renderer.appendChild(this.wrapper, this.overlay);
  }

  private attachHoverEvents() {
    this.renderer.listen(this.wrapper, 'mouseenter', () => {
      this.renderer.setStyle(this.overlay, 'opacity', '1');
    });

    this.renderer.listen(this.wrapper, 'mouseleave', () => {
      this.renderer.setStyle(this.overlay, 'opacity', '0');
    });
  }

  private destroyOverlay() {
    const img = this.el.nativeElement;
    if (this.wrapper && this.wrapper.parentNode) {
      const parent = this.wrapper.parentNode as HTMLElement;
      const img = this.el.nativeElement;
      if (this.wrapper.contains(img)) {
        this.renderer.insertBefore(parent, img, this.wrapper);
      }      
      if (parent.contains(this.wrapper)) {
        this.renderer.removeChild(parent, this.wrapper);
      }
    }

    this.renderer.removeAttribute(img, 'style');
    this.wrapper = undefined;
    this.overlay = undefined;
  }

  ngOnDestroy() {
    this.destroyOverlay();
  }
}
